// extracted by mini-css-extract-plugin
module.exports = {"tertiary":"CustomButton_tertiary___kxJr","root":"CustomButton_root__3CriW","grommetux-button__icon":"CustomButton_grommetux-button__icon__3xUxm"};